import {Component, Input, OnInit} from "@angular/core";
import {FileSelectEvent} from "primeng/fileupload";
import {HgPartnerService} from "../../../../../../service/api/hg-partner.service";
import {EmSchemaRuntimeDataDto} from "../../../../../../../em/model/dto/api/em-schema-runtime-data.dto";

@Component({
    selector: 'hg-gdv-test-component',
    templateUrl: 'hg-test.component.html',
    standalone: false
})

export class HgTestComponent implements OnInit {

    @Input() hgPartnerId: number;

    busy: boolean;

    emSchemaRuntimeDataDto: EmSchemaRuntimeDataDto;
    selectedFile: File;

    constructor(
        protected hgPartnerService: HgPartnerService) {
    }

    ngOnInit() {

    }

    onFileSelect(event: FileSelectEvent) {
        this.selectedFile = event.files[0];
    }

    /**
     * Process the selected GDV file using the unified merged structure.
     */
    processDocument(fileUploader: any) {

        if (this.busy || !this.selectedFile) {
            return;
        }

        this.busy = true;

        this.hgPartnerService.processFileMerged(this.hgPartnerId, this.selectedFile).subscribe({
            next: (res) => {
                this.emSchemaRuntimeDataDto = res;
                this.busy = false;
            },
            error: () => {
                this.emSchemaRuntimeDataDto = null;
                this.busy = false;
            }
        });
    }

}
